import { render, staticRenderFns } from "./IcoPeopleCapability.vue?vue&type=template&id=09054226"
import script from "./IcoPeopleCapability.vue?vue&type=script&lang=js"
export * from "./IcoPeopleCapability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports